// extracted by mini-css-extract-plugin
export default {"skeleton-loader":"sBeN0XR","gradient":"FHTbLk3","skeleton-loader--pill":"Pt11E2K"};